import moment from 'moment'

const EMAIL_PATTERN = "[A-Za-z0-9_.%+-]+@[A-Za-z0-9.-]+[.][a-z]{2,13}";
const TEL_PATTERN = "[+0][0-9/ -]{5,}";
//const WEB_PATTERN = "https?://.+";
const WEB_PATTERN = ".+";
export const DATETIME_PATTERN = "\d\d\d\d-(\d)?\d-(\d)?\d \d\d:\d\d:\d\d$";


export const TYPES = {
    0: {
		OPTION: {VALUE: '0', TEXT: 'Telefon'},
		SYMBOL: {CLASS: 'glyphicon-earphone',TITLE: 'Telefon'},
		CONTENT: {PATTERN: TEL_PATTERN, PLACEHOLDER:"089..."},
	},
    1: {
		OPTION: {VALUE: '1', TEXT: 'Mobil'},
		SYMBOL: {CLASS: 'glyphicon-phone', TITLE: 'Mobil'},
		CONTENT: {PATTERN: TEL_PATTERN, PLACEHOLDER:"+49170 ..."},
	},
    2: {
		OPTION: {VALUE: '2', TEXT: 'Email'},
		SYMBOL: {CLASS: 'glyphicon-envelope', TITLE: 'Email'},
		CONTENT: {PATTERN: EMAIL_PATTERN, PLACEHOLDER:"max@muster.com"},
	},
    3: {
		OPTION: {VALUE: '3', TEXT: 'Fax'},
		SYMBOL: {CLASS: 'glyphicon-print', TITLE: 'Fax'},
		CONTENT: {PATTERN: TEL_PATTERN, PLACEHOLDER:"+4989..."},
	},
    4: {
		OPTION: {VALUE: '4', TEXT: 'Web'},
		SYMBOL: {CLASS: 'glyphicon-globe', TITLE: 'Web'},
		CONTENT: {PATTERN: WEB_PATTERN, PLACEHOLDER:"http://.."},
	},
    5: {
		OPTION: {VALUE: '5', TEXT: 'intern'},
		SYMBOL: {CLASS: 'glyphicon-user', TITLE: 'intern'},
		CONTENT: {PATTERN:".", PLACEHOLDER:""},
	},
    6: {
		OPTION: {VALUE: '6', TEXT: 'Google Kalender'},
		SYMBOL: {CLASS: 'glyphicon-calendar', TITLE: 'Google Kalender'},
		CONTENT: {PATTERN:".", PLACEHOLDER:""},
	},
    7: {
		OPTION: {VALUE: '7', TEXT: 'Web Formular'},
		SYMBOL: {CLASS: 'glyphicon-globe', TITLE: 'Web Formular'},
		CONTENT: {PATTERN: WEB_PATTERN, PLACEHOLDER:""},
	},
    8: {
		OPTION: {VALUE: '8', TEXT: 'Sammelemail mit Anhang'},
		SYMBOL: {CLASS: 'glyphicon-envelope', TITLE: 'Sammelemail mit Anhang'},
		CONTENT: {PATTERN: EMAIL_PATTERN, PLACEHOLDER:""},
	},
    9: {
		OPTION: {VALUE: '9', TEXT: 'Sammelemail als Liste'},
		SYMBOL: {CLASS: 'glyphicon-envelope', TITLE: 'Sammelemail als Liste'},
		CONTENT: {PATTERN: EMAIL_PATTERN, PLACEHOLDER:""},
	},
    10: {
		OPTION: {VALUE: '10', TEXT: 'Sammelfax'},
		SYMBOL: {CLASS: 'glyphicon-print', TITLE: 'Sammelfax'},
		CONTENT: {PATTERN: TEL_PATTERN, PLACEHOLDER:""},
	},
    11: {
		OPTION: {VALUE: '11', TEXT: 'Download'},
		SYMBOL: {CLASS: 'glyphicon-download', TITLE: 'Download'},
		CONTENT: {PATTERN: WEB_PATTERN, PLACEHOLDER:""},
	},
    12: {
		OPTION: {VALUE: '12', TEXT: 'Tabelle'},
		SYMBOL: {CLASS: 'glyphicon-th-list', TITLE: 'Tabelle'},
		CONTENT: {PATTERN: WEB_PATTERN, PLACEHOLDER:""},
	},
    13: {
		OPTION: {VALUE: '13', TEXT: 'Email im IMMOXML format'},
		SYMBOL: {CLASS: 'glyphicon-envelope', TITLE: 'Email im IMMOXML format'},
		CONTENT: {PATTERN: EMAIL_PATTERN, PLACEHOLDER:""},
	},
    14: {
		OPTION: {VALUE: '14', TEXT: 'externe Webseite'},
		SYMBOL: {CLASS: 'glyphicon-globe', TITLE: 'externe Webseite'},
		CONTENT: {PATTERN: WEB_PATTERN, PLACEHOLDER:""},
	},
};

/* Beim Anrufer weniger anzeigen */
export const TYPES_USERCALLER = {
  0: TYPES[0],
  1: TYPES[1],
  2: TYPES[2],
  3: TYPES[3],
  4: TYPES[4]
};


export const SUBTYPES = {
    0: {
		OPTION: {VALUE: '0', TEXT: 'Text-Standard klein'},
	},
    1: {
		OPTION: {VALUE: '1', TEXT: 'Text-39 klein'},
	},
    2: {
		OPTION: {VALUE: '2', TEXT: 'Text-21 klein'},
	},
    3: {
		OPTION: {VALUE: '3', TEXT: 'Text-22 klein'},
	},
    4: {
		OPTION: {VALUE: '4', TEXT: 'Text-23 klein'},
	},
    5: {
		OPTION: {VALUE: '5', TEXT: 'Text-39'},
	},
    6: {
		OPTION: {VALUE: '6', TEXT: 'HTML-24'},
	},
    7: {
		OPTION: {VALUE: '7', TEXT: 'HTML-41'},
	},
    8: {
		OPTION: {VALUE: '8', TEXT: 'HTML-41U'},
	},
    9: {
		OPTION: {VALUE: '9', TEXT: 'Wiki-Standard klein'},
	},
    10: {
		OPTION: {VALUE: '10', TEXT: 'Wiki-Standard'},
	},
    11: {
		OPTION: {VALUE: '11', TEXT: 'HTML-42'},
	},
    12: {
		OPTION: {VALUE: '12', TEXT: 'HTML-43'},
	},
    13: {
		OPTION: {VALUE: '13', TEXT: 'Text-25'},
	},
};

export const ACLS = {
    0: {
      OPTION: {VALUE: '0', TEXT: ''},
      SYMBOL: {CLASS: 'acl-public', TITLE: 'öffentlich'},
	},
    1: {
      OPTION: {VALUE: '1', TEXT: 'öffentlich'},
      SYMBOL: {CLASS: 'acl-public', TITLE: 'öffentlich'},
	},
    2: {
      OPTION: {VALUE: '2', TEXT: 'intern'},
      SYMBOL: {CLASS: 'acl-intern', TITLE: 'intern'},
	},
    3: {
      OPTION: {VALUE: '3', TEXT: 'privat'},
      SYMBOL: {CLASS: 'acl-privat', TITLE: 'privat'},
	},
};

export const SHIPPING_ACTIV = {
    0: {
      OPTION: {VALUE: '0', TEXT: 'Kein Versand'},
	},
    1: {
      OPTION: {VALUE: '1', TEXT: 'Versand'},
	},
    2: {
      OPTION: {VALUE: '2', TEXT: 'Versandfähig'},
	},
    3: {
      OPTION: {VALUE: '3', TEXT: 'Versand global'},
	},
};





export const DEFAULT_OBJECT = {
      validTimes:"",
      id:"",
      datetimeShippingEnd:"2029-12-31 00:00:00",
      datetimeShippingBegin: moment().format('YYYY-MM-DD HH:mm:ss'),
      datetimeUpdate:"0000-00-00 00:00:00",
      acl:"1",
      description:"",
      content:"",
      datetimeRegister:"0000-00-00 00:00:00",
      datetimeBegin: moment().format('YYYY-MM-DD HH:mm:ss'),
      datetimeEnd:"2029-12-31 00:00:00",
      idCompany: '0',
      idParent:"0",
      idUser: '0',
      shippingActiv:"0",
      subType:"0",
      type:"0"
};







// WEBPACK FOOTER //
// ./src/common/kombox.conf.js